export class ServiceArea {
    public id: number;
    public name : string;
    public parent : ServiceArea;
    public children : ServiceArea[];
    public latitude: number;
    public longitude: number;
    public isDeleted: boolean;
}


// WEBPACK FOOTER //
// /app/SPA/src/app/models/serviceArea.ts